import { useQuery } from 'react-query'
import { getCashBoxMessages } from 'services/messages'

export default function useGetCashboxMessages() {
    const { data, isLoading } = useQuery(
        ['cashbox-messages'],
        getCashBoxMessages
    )
    return { cashboxData: data }
}
